import { HttpInterceptorFn } from '@angular/common/http';
import { StorageService } from '../../services/storage/storage.service';
import { inject } from '@angular/core';



export const cachingInterceptor: HttpInterceptorFn = (req, next) => {
  if (!navigator.onLine && ['POST', 'PUT', 'DELETE'].includes(req.method)) {
    const storageService: StorageService = inject(StorageService),
          key = new Date().toISOString(),
          data = { key, api: req.url, payload: req.body, isSynchronized: false };

    storageService.saveOfflineData(key, data)
      .then(() => console.warn('Sin conexión. Los datos se guardaron localmente.'))
      .catch((err: any) => console.error('Los datos no se lograron guardar localmente.', err));

    return next(req);

  } else { return next(req); }
};
